module.exports = __webpack_public_path__ + "/img/f5546d22289fd47b1eb6db94cf36e579.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/client/assets/appimg/ewelcome-004.png
 ** module id = 25
 ** module chunks = 0 4 5
 **/